const config = {
    dirtyClass: 'dirty',
    dirtyFieldClass: 'dirty-field'
};

export default class FormDirty {
    constructor(element) {
        this.$element = $(element);
        this.initialState = {};
    }

    computeState() {
        let ret = {};
        this.$element.find('input, select').each((index, el) => {
            let $currentField = $(el);
            if ($currentField.is(':checkbox') || $currentField.is(':radio')) {
                ret[$currentField.attr('id')] = $currentField.is(':checked');
            } else {
                ret[$currentField.attr('id')] = $currentField.val();
            }
        });

        return ret;
    }

    changeHandler(event) {
        let currentState = this.computeState();

        if (JSON.stringify(this.initialState) !== JSON.stringify(currentState)) {
            this.$element.addClass(config.dirtyClass);
            $(event.target).addClass(config.dirtyFieldClass);
            this.$element.trigger('form:dirty:change');
        }
    }

    init() {
        this.$element.find('input, select')
            .off('change.dirty', '', $.proxy(this, 'changeHandler'))
            .on('change.dirty', $.proxy(this, 'changeHandler'));
        this.initialState = this.computeState();
    }
}